import "./NotFound.scss";
import { Link } from "react-router-dom";
import { FiHome, FiArrowLeft } from "react-icons/fi";

export const NotFound = ({ home = "/" }) => {
    return (
        <div className="notfound-page">
            <div className="notfound-card">
                <div className="notfound-code">404</div>
                <h1 className="notfound-title">Página no encontrada</h1>
                <p className="notfound-description">
                    La página que buscas no existe o fue movida.
                </p>
                <div className="notfound-actions">
                    <button
                        onClick={() => window.history.back()}
                        className="notfound-btn secondary"
                    >
                        <FiArrowLeft /> Volver atrás
                    </button>
                    <Link to={home} className="notfound-btn primary">
                        <FiHome /> Ir al inicio
                    </Link>
                </div>
            </div>
        </div>
    );
};
